<template>
  <v-checkbox hide-details v-model="localValues" class="align-center">
    <template v-slot:prepend>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="pointer" :color="color">{{ icon }}</v-icon>
        </template>
        <span>{{ $vuetify.lang.t(text) }}</span>
      </v-tooltip>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: 'checkboxIconedBasic',
  props: {
    category: String,
    field: String,
    value: Boolean,
    icon: String,
    emitString: String,
    text: String,
    color: String
  },
  computed: {
    localValues: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit(this.emitString, { category: this.category, field: this.field, value })
      }
    }
  }
}
</script>

<style scoped>

</style>
